<template>
    <li class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-165">
        <router-link :to="'/archive/' + id + '?name=' + name">{{name}}</router-link>
    </li>
</template>

<script>
    export default {
        name: 'headerArchives',
        props: ['id', 'name']   /*  props是子组件获取父组件数据用的 */
    }
</script>



// WEBPACK FOOTER //
// src/components/headerArchives.vue